export default __webpack_public_path__ + "static/media/print_ficha.abac9cf3.jpg";